import React, { useRef } from 'react';
import { css } from "@emotion/react"
import { navigate } from "gatsby"
import ProyectoEntry from '../../organisms/ProyectoEntry/ProyectoEntry';
import VerMas from '../../molecules/VerMas/VerMas';

export default function MostrarProyectos({ proyectos }) {

  const filaRef = useRef(null)

  const verSiguiente = (event) => {
    event.preventDefault()
    event.stopPropagation()
    const fila = filaRef.current
    if (!fila) return
    const limite = fila.scrollWidth - fila.clientWidth
    if (limite <= 2 || fila.scrollLeft >= limite - 2) {
      navigate("/proyectos/")
      return
    }
    const card = fila.firstElementChild
    const margen = card ? parseFloat(getComputedStyle(card).marginRight) || 0 : 0
    fila.scrollBy({
      left: card ? card.offsetWidth + margen : fila.clientWidth * 0.5,
      behavior: "smooth",
    })
  }

  const sliderCss = css`
    position: relative;
  `;

  const flechaCss = css`
    position: absolute;
    z-index: 5;
    top: 0;
    right: 0;
    bottom: 0;
    width: calc(100vw * (calc(110 / var(--width_base))));
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 calc(100vw * (calc(18 / var(--width_base)))) 0 0;
    border: 0;
    background: transparent;
    cursor: pointer;
    & svg {
      width: calc(100vw * (calc(19 / var(--width_base))));
      height: calc(100vw * (calc(39 / var(--width_base))));
      pointer-events: none;
      flex-shrink: 0;
    }
  `;

  const contentProyectosCss = css`
    display: flex;
    clear: both;
    width: 100%;
    overflow-x: auto;
    scroll-behavior: smooth;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
    &.only-desk{
      @media (max-width: 767px){
        display: none;
      }
    }
  `;

  const entryCss = css`
    margin-right: calc(100vw * (calc(72 / var(--width_base))));
    flex-shrink: 0;
    overflow: hidden;
  `;

  const imagenOverlayCss = css`
     width: calc(100vw * (calc(791 / var(--width_base))));
     height: calc(100vw * (calc(619 / var(--width_base))));
     object-fit: cover;
    
    @media (max-width: 1440px) and (min-width: 1025px) {
      width: calc(100vw * (calc(591 / var(--width_base))));
      height: calc(100vw * (calc(419 / var(--width_base))));
    }
    
     @media (max-width: 1024px) and (min-width: 768px) {
       width: calc(100vw * (calc(491 / var(--width_base))));
       height: calc(100vw * (calc(319 / var(--width_base)))); 
     }
  `;

  return (
    <>
      <div css={sliderCss} className="only-desk">
        <div css={contentProyectosCss} ref={filaRef}>
          {
            proyectos && proyectos.map((proyecto, i) => (
              <ProyectoEntry
                key={proyecto?.databaseId || i}
                proyecto={proyecto}
                keyEle={i}
                styleEle={entryCss}
                styleImageEle={imagenOverlayCss}
              />
            ))
          }
        </div>
        {proyectos?.length > 0 && (
          <button type="button" css={flechaCss} onClick={verSiguiente} aria-label="Siguiente proyecto">
            <svg role="img" aria-hidden="true" width="24" height="43" viewBox="0 0 24 43" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 2L21 21.5L2 41" stroke="white" strokeWidth="3" />
            </svg>
          </button>
        )}
      </div>
      <div className="only-mov">
        {
          proyectos && proyectos.map((proyecto, i) => (
            <ProyectoEntry
              proyecto={proyecto}
              keyEle={i}
            />
          ))
        }
        <VerMas />
      </div>
    </>
  );

}